exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3HRJG{width:1180px;margin:0 auto}._9_qZK{font-size:26px;color:#31404c;margin:30px 0 20px}._9_qZK p{margin-left:20px;display:inline-block;font-weight:400;line-height:25px;font-size:18px;color:#a7b0b8}._9_qZK p span{color:#ff9830}", ""]);

// exports
exports.locals = {
	"content": "_3HRJG",
	"title": "_9_qZK"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/routes/serial/serial/Serial.css
// module id = 1212
// module chunks = 5